// Fetch request manager for handling fetch abort on logout
class FetchManager {
  constructor() {
    this.controllers = new Set();
    this.setupLogoutListener();
  }

  // Create a new AbortController and register it
  createController() {
    const controller = new AbortController();
    this.controllers.add(controller);
    return controller;
  }

  // Remove a controller from the managed set once request is complete
  removeController(controller) {
    this.controllers.delete(controller);
  }

  // Abort all active fetch requests
  abortAll() {
    console.log(`Aborting ${this.controllers.size} pending fetch requests`);
    for (const controller of this.controllers) {
      try {
        controller.abort();
      } catch (error) {
        console.error("Error aborting fetch request:", error);
      }
    }
    this.controllers.clear();
  }

  // Set up a listener for the custom logout event
  setupLogoutListener() {
    window.addEventListener("app-logout", () => {
      console.log(
        "FetchManager: Detected logout, cancelling all pending requests"
      );
      this.abortAll();
    });
  }
}

// Singleton instance
const fetchManager = new FetchManager();

export const managedFetch = async (url, options = {}, currentUser = null) => {
  const controller = fetchManager.createController();
  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    });

    if (response.status === 401 && currentUser) {
      console.log("Token expired, refreshing and retrying request");
      const refreshedToken = await currentUser.getIdToken(true);

      const retryResponse = await fetch(url, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${refreshedToken}`,
        },
        signal: controller.signal,
      });

      return retryResponse;
    }

    return response;
  } catch (error) {
    if (error.name === "AbortError") {
      console.log(`Request to ${url} was aborted`);
    } else {
      throw error;
    }
  } finally {
    fetchManager.removeController(controller);
  }
};

export default fetchManager;
